import Arrow from "@/public/assets/images/arrow-circle-left.svg";
import { useSwiper } from "swiper/react";

type GalleryButtonsProps = {
  disablePrev: boolean;
  disableNext: boolean;
};

const GalleryButtons = ({ disableNext, disablePrev }: GalleryButtonsProps) => {
  const swiper = useSwiper();
  return (
    <>
      <button
        className="gallery__button gallery__button--prev"
        onClick={() => {
          swiper.slidePrev();
        }}
        disabled={disablePrev}
      >
        <Arrow />
      </button>
      <button
        className="gallery__button gallery__button--next"
        onClick={() => {
          swiper.slideNext();
        }}
        disabled={disableNext}
      >
        <Arrow />
      </button>
    </>
  );
};

export default GalleryButtons;
